<script lang="ts">
  import Loading from "$components/+shared/Loading/Loading.svelte";
  import TopBarLayout from "../TopBar/TopBarLayout.svelte";

  export let loading: boolean = false;
  export let hideLogin: boolean = false;
  export let ref: HTMLDivElement | undefined = undefined;
  export let fullWidth: boolean = true;
</script>

<slot name="topbar">
  <TopBarLayout {hideLogin}>
    <svelte:fragment slot="left-section">
      <slot name="heading" />
    </svelte:fragment>

    <svelte:fragment slot="right-section">
      <slot name="action-buttons" />
    </svelte:fragment>
  </TopBarLayout>
</slot>

{#if loading}
  <Loading />
{:else}
  <!-- id used as a reference in LinkHandle.ts -->
  <div
    id="main-panel-container"
    bind:this={ref}
    class="scrollbar-stable scrollbar-invisible hover:scrollbar-visible scrollbar-thin relative size-full overflow-y-auto overflow-x-hidden px-4 pb-[140px] pt-5 md:px-5"
  >
    <div
      class="mx-auto max-w-full transition-[width] duration-[180ms] @container/main-panel-container"
      style="width: {fullWidth ? '100%' : 'clamp(300px, 100%, 844px)'}"
    >
      <slot />
    </div>
  </div>
{/if}

<div class="absolute bottom-4 left-1/2 -translate-x-1/2">
  <slot name="bottom-floating-element" />
</div>
